import React, { useEffect, useState } from 'react';
import DataTable from "../../../components/DataTable/DataTable";
import OneTest from "../../../components/dashboards/students/MyTestScores/OneTestPaper"
import StatusGenerator from '../../../components/TransactionLog/StatusGenerator';
export const PerformaceTable = ({ getStudentPerformance, selectedUser }) => {
    const [allStudentData, setAllStudentData] = useState([]);

    const filteredUserCategory = getStudentPerformance?.map((item =>({
        Name:item?.name,
        Subject: item?.subjectName,
        "Paper Type":item?.paperType,
        "Total Score":item?.totalScore,
        Grade:item?.grade,

    })))
         
    



    const columns = [
        {
            name: "S/N",
            label: "S/N",
            options: {
                customBodyRender: (value, tableMeta) => {
                    return <span>{tableMeta.rowIndex + 1} </span>;
                },
            }

        },
        {
            name: "name",
            label: "Student",
            //   options: {
            //     customBodyRender: (value, tableMeta) => {
            //       const email = tableMeta.rowData[1];
            //       return <AvatarWithText text={value.FullName} email={value.Email} />;
            //       // return <AvatarWithText text={value} email={email} />;
            //     },
            //   },
        },
        // {
        //     //   name: "Email",
        //     label: "Subject",
        //     options: {

        //         setCellProps: () => ({ style: { minWidth: "180px", padding: "20px" } }),
        //     },
        // },
        {
            name: "paperType",
            label: "Paper Type",
            options: {

                setCellProps: () => ({ style: { minWidth: "180px", padding: "20px" } }),
            },
        },

        {
            name: "totalScore",
            label: "Avg Score",
            options: {
                setCellProps: () => ({ style: { minWidth: "180px", padding: "20px" } }),
            },
        },

        {
            name: "grade",
            label: "Grade",
            options: {
                setCellProps: () => ({ style: { minWidth: "180px", padding: "20px", padding: "dense", } }),
                customBodyRender: (value, tableMeta) => {
                    const lowerCaseValue =
                        typeof value === "string" ? value?.toLowerCase() : value;
                    switch (lowerCaseValue) {
                        case "f9":
                        case "e8":
                            return (
                                <StatusGenerator
                                    statusText={value?.toUpperCase()}
                                    variant="redFilled" />
                            );
                        case "a1":
                            return (
                                <StatusGenerator statusText="A1" variant="greenFilled" />
                            );
                        case "b2":
                        case "b3":
                            return (
                                <StatusGenerator
                                    statusText={value?.toUpperCase()}
                                    variant="blueFilled"
                                />
                            );
                        case "c4":
                        case "c5":
                        case "c6":
                        case "d7":
                            return (
                                <StatusGenerator
                                    statusText={value?.toUpperCase()}
                                    variant="yellowFilled"
                                />
                            );
                        default:
                            return "no status";
                    }
                },
            },
        },


    ];


    return (
        <DataTable
            tableName={"Student Performance"}
            data={getStudentPerformance}
            columns={columns}
            count={10}
            page={10}
            search={true}
            serverSide={false}
            fileName={`Student Performance ${selectedUser}`}
            formatData={filteredUserCategory}

        />
    )
}
